import clsx from '@/lib/clsx';

const WizardTitle = ({ children, className = '', ...props }) => {
  return (
    <h2 className={clsx('comp-wizard-title', className)} {...props}>
      {children}
    </h2>
  );
};

export default WizardTitle;
